'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var useLocale = require('@narvar/nth-hook-locale');
var nthHookTheme = require('@narvar/nth-hook-theme');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var nthHookSettings = require('@narvar/nth-hook-settings');
var nthHookGlobalSettings = require('@narvar/nth-hook-global-settings');
var useIsMobile = require('../../../common/providers/useIsMobile.js');
var nthHookLoma = require('@narvar/nth-hook-loma');
var SessionContext = require('../../../common/providers/SessionContext.js');
var index = require('../../../common/providers/ClaimBuilder/index.js');
var useAnalytics = require('../../../common/providers/useAnalytics.js');
var PrefetchData = require('./PrefetchData.js');
var useTitanAnalytics = require('../../../common/providers/titan/useTitanAnalytics.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var useLocale__default = /*#__PURE__*/_interopDefaultLegacy(useLocale);

const VersionDependentClaimsProviders = _ref => {
  let {
    localeCountry,
    localeLanguage,
    params,
    config,
    children
  } = _ref;
  const {
    retailerMoniker,
    versionName,
    orderNumber,
    source,
    devMode,
    cache,
    email,
    claimType
  } = params;
  const {
    data,
    loading
  } = nthHookLoma.useGetTrackSegmentedExperienceForClaimsQuery({
    variables: {
      retailerMoniker,
      versionName,
      localeCountry,
      localeLanguage
    }
  });
  if (loading) return null;
  return /*#__PURE__*/React__default["default"].createElement(nthHookTheme.LomaThemeConfigProvider, {
    product: "narvarjs",
    retailerMoniker: retailerMoniker,
    versionName: (data === null || data === void 0 ? void 0 : data.segmentedExperience.versionName) || '',
    localeLanguage: localeLanguage,
    localeCountry: localeCountry,
    cache: cache
  }, /*#__PURE__*/React__default["default"].createElement(SessionContext.SessionProvider, {
    value: {
      portalType: 'customer',
      retailerMoniker,
      orderNumber: orderNumber ?? '',
      email,
      claimType,
      versionName: (data === null || data === void 0 ? void 0 : data.segmentedExperience.versionName) || '',
      handleError: config.handleError,
      returnsPortalUrlTemplate: config.RETURNS_PORTAL_URL_TEMPLATE,
      localeLanguage,
      localeCountry,
      source,
      devMode,
      cache
    }
  }, /*#__PURE__*/React__default["default"].createElement(PrefetchData["default"], null, /*#__PURE__*/React__default["default"].createElement(index["default"], null, /*#__PURE__*/React__default["default"].createElement(useTitanAnalytics.TitanAnalyticsProvider, {
    value: config.titan
  }, children)))));
};
const LocaleDependendentClaimsProviders = _ref2 => {
  let {
    localeCountry,
    localeLanguage,
    params,
    config,
    children
  } = _ref2;
  const {
    retailerMoniker,
    cache
  } = params;
  const isMobile = useIsMobile["default"]();
  const category = isMobile ? 'MOBILE' : 'DESKTOP';
  return /*#__PURE__*/React__default["default"].createElement(nthHookGlobalSettings.LomaGlobalSettingsConfigProvider, {
    retailerMoniker: retailerMoniker,
    localeLanguage: localeLanguage,
    localeCountry: localeCountry,
    cache: cache
  }, /*#__PURE__*/React__default["default"].createElement(nthHookTranslations.LomaTranslationsConfigProvider, {
    product: "claims_translations",
    retailerMoniker: retailerMoniker,
    localeLanguage: localeLanguage,
    localeCountry: localeCountry,
    cache: cache
  }, /*#__PURE__*/React__default["default"].createElement(nthHookSettings.LomaSettingsConfigProvider, {
    product: "claims",
    retailerMoniker: retailerMoniker,
    versionName: "",
    localeLanguage: localeLanguage,
    localeCountry: localeCountry,
    category: category,
    cache: cache
  }, /*#__PURE__*/React__default["default"].createElement(VersionDependentClaimsProviders, {
    localeCountry: localeCountry,
    localeLanguage: localeLanguage,
    params: params,
    config: config
  }, children))));
};
const ClaimsProviders = _ref3 => {
  let {
    params,
    config,
    children
  } = _ref3;
  const {
    locale,
    loading
  } = useLocale__default["default"]();
  const {
    retailerMoniker,
    source
  } = params;
  const {
    handleError,
    NOFLAKE_URL
  } = config;
  if (loading) return null;
  const localeLanguage = (useLocale.isValidLanguage(params.localeLanguage) ? params.localeLanguage : locale.language) ?? 'en';
  const localeCountry = (useLocale.isValidCountry(params.localeCountry) ? params.localeCountry : locale.country) ?? 'US';
  return /*#__PURE__*/React__default["default"].createElement(useAnalytics.AnalyticsProvider, {
    value: {
      retailerMoniker,
      noflakeUrl: NOFLAKE_URL,
      localeLanguage,
      localeCountry,
      source,
      errorCallback: handleError
    }
  }, /*#__PURE__*/React__default["default"].createElement(useLocale.LocaleProvider, {
    value: {
      parameters: {
        country: localeCountry,
        language: localeLanguage,
        retailerMoniker
      },
      handleError
    }
  }, /*#__PURE__*/React__default["default"].createElement(LocaleDependendentClaimsProviders, {
    localeLanguage: localeLanguage,
    localeCountry: localeCountry,
    params: params,
    config: config
  }, children)));
};

exports["default"] = ClaimsProviders;
